import { Node } from '../class';

export class AwaitNode extends Node {
  public icon = 'restore';
  public readonly extraProperties = [];
}
